import styled from 'styled-components';

export const FormLabel = styled.p`
  font-size: 16px;
  font-weight: ${props => (props.isEnabled ? '500' : '500')};
  color: ${props => (props.isEnabled ? '#4b286d' : '#666')};
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
`;

export const ToggleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 2rem;
  border: 1px solid ${props => (props.isEnabled ? '#4b286d' : '#e4e4e4')};
  padding: 1.75rem;
  border-radius: 1rem;
`;
